<template>
  <v-app>
    <v-content :style="'background-color:' + background_color + ';'">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import { EventBus } from './EventBus';
export default {
  name: 'App',
  
  data: () => ({

    //web theme colors
    background_color: '#F4F5F7'
  }),
  mounted () {
    EventBus.$on('paddingAlert', this.paddingAlert)
    EventBus.$on('closeAlert', this.closeAlert)
  },
  beforeDestroy() {
    EventBus.$off('paddingAlert')
    EventBus.$off('closeAlert')
  },
  methods: {
    closeAlert() {
      this.$swal.close()
    },
    paddingAlert (title="กำลังดำเนินการ", alert_text="ทดสอบ", timer=5000) {
      this.$swal({
        backdrop: false,
        position: 'top-end',
        width: '353px',
        title: `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_ajPY{transform-origin:center;animation:spinner_AtaB .75s infinite linear}@keyframes spinner_AtaB{100%{transform:rotate(360deg)}}</style><path stroke="#3157c0d4" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner_ajPY" stroke="#3157c0d4"/></svg><b class="alert-padding-title">${title}</b>`,
        html: alert_text,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          container: 'alert-card-block',
          popup: 'alert-card-padding',
          title: 'alert-title-block-v2',
          closeButton: 'alert-close-btn',
          htmlContainer: 'alert-text-box'
        }
      })
    }
  }
};
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Sarabun&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai&display=swap');
  @font-face {
    font-family: 'Thai Sarabun ๙';
    src: url('./assets/font/THSarabunIT๙.ttf');
  }

  .web-bg {
    background-color: #F4F5F7;
  }

  /*==================================== Alert CSS =============================*/
  .alert-card {
    padding-bottom: 16px !important;
  }
  
  .alert-title-block {
    text-align: left !important;
    padding-left: 6% !important;
    padding-top: 0% !important;
  }

  .alert-icon {
    vertical-align: middle;
  }

  .alert-title {
    font-family: 'Sarabun', sans-serif;
    font-size: 16px;
    color: black;
    margin-left: 18px;
    vertical-align: middle;
  }

  .close-alert-btn {
    font-size: 23px !important;
    margin-right: 4% !important;
    margin-top: 3% !important;
    color: gray !important;
  }

  .close-alert-btn:hover {
    color: lightgray !important;
  }

  .alert-text-block {
    font-family: 'Sarabun', sans-serif;
    font-size: 14px !important;
    text-align: left !important;
    margin-left: 63px !important;
    margin-top: 2% !important;
    margin-bottom: 0% !important;
    line-height: 22px !important;
  }

  /*=============================================================================*/

  /*==================================== Alert CSS V2 =============================*/
  .alert-card-block {
    top: 82px !important;
  }

  .alert-card-success {
    border-radius: 8px !important;
    border: 2px solid #4CAF1E !important;
    padding-bottom: 12px !important;
  }
  .alert-card-padding {
    border-radius: 8px !important;
    border: 2px solid #3157c0 !important;
    padding-bottom: 12px !important;
  }

  .alert-card-error {
    border-radius: 8px !important;
    border: 2px solid #C00C0C !important;
    padding-bottom: 12px !important;
  }
  .alert-card-error-new {
    border-radius: 8px !important;
    border: 2px solid #f7bb07 !important;
    padding-bottom: 12px !important;
  }

  .alert-success-title {
    font-family: 'Sarabun', sans-serif;
    font-size: 20px;
    color: #4CAF1E;
    margin-left: 15px;
  }

  .alert-error-title {
    font-family: 'Sarabun', sans-serif;
    font-size: 20px;
    color: #C00C0C;
    margin-left: 15px;
  }
  .alert-error-title-new {
    font-family: 'Sarabun', sans-serif;
    font-size: 20px;
    color: #f7bb07;
    margin-left: 15px;
  }
  .alert-padding-title {
    font-family: 'Sarabun', sans-serif;
    font-size: 20px;
    color: #3157c0;
    margin-left: 15px;
  }

  .alert-title-block-v2 {
    text-align: start !important;
    padding-left: 11px !important;
    padding-right: 9px !important;
    padding-top: 10px !important;
    display: flex !important;
    align-items: flex-end;
  }

  .alert-close-btn {
    font-size: 24px !important;
    margin-right: 9px !important;
    padding-top: 7px !important;
  }

  .alert-text-box {
    font-family: 'Sarabun', sans-serif;
    color: #606266 !important;
    font-size: 14px !important;
    text-align: start !important;
    margin-top: 0px !important;
    margin-right: 11px !important;
    margin-left: 50px !important;
    line-height: 22px !important;
  }
  /*=============================================================================*/

  /*==================================== loading CSS =============================*/
  .loading-circle {
    opacity: 0.6;
  }

  .loading-circle-v2 {
    position: fixed !important;
    top: 45%;
  }
  /*=============================================================================*/  

  /*========================================*/

  @media only screen and (max-width:600px){ /*css for mobile screen*/
    .display-pc-only {
      display: none !important;
    }

    .loading-circle-v2 {
      left: 40%;
    }
  }

  /*==========================================*/

  @media only screen and (min-width: 600px) { /*css for pc screen*/
    .display-mobile-only {
      display: none !important;
    }
  }
</style>
